/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BaseIssuanceRetailerProductExclusion } from './BaseIssuanceRetailerProductExclusion';
import type { DisplayCompany } from './DisplayCompany';
import type { RetailerTranslation } from './RetailerTranslation';

export type Retailer = {
    id: number;
    name: string;
    imageMetadataId: string;
    nameTemplate: string;
    status: Retailer.status;
    effectiveFrom?: string;
    effectiveTo?: string;
    isContainPii?: boolean;
    company: DisplayCompany;
    regions: Array<'AB' | 'BC' | 'MB' | 'NB' | 'NL' | 'NT' | 'NS' | 'NU' | 'ON' | 'TB' | 'PE' | 'QC' | 'SK' | 'YT'>;
    translations: Array<RetailerTranslation>;
    isExcludedFromCompanyPostProcessors: boolean;
    sponsorCode: string;
    isEnabledBaseIssuance: boolean;
    baseIssuanceProductExclusions?: Array<BaseIssuanceRetailerProductExclusion>;
};

export namespace Retailer {

    export enum status {
        ACTIVE = 'ACTIVE',
        DISABLED = 'DISABLED',
        EXPIRED = 'EXPIRED',
        UPCOMING = 'UPCOMING',
    }


}

